











import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    blok: { type: Object, required: true },
  },
  mounted() {
    setTimeout(() => {
      const player: any = this.$refs.player;
      player.load(this.blok.json.filename);
    }, 200);
  }
});
